<template>
  <transition name="toast-fade">
    <div class="toast" v-if="visible" :class="type">
      <span class="toast-icon" v-if="type === 'success'">✓</span>
      <span class="toast-icon" v-else-if="type === 'error'">✕</span>
      <span class="toast-icon" v-else>!</span>
      <span class="toast-text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'H5Toast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: (val) => ['success', 'error', 'info'].includes(val)
    }
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 80%;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.toast.success {
  background: rgba(103, 194, 58, 0.95);
}

.toast.error {
  background: rgba(245, 108, 108, 0.95);
}

.toast-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.toast-text {
  line-height: 1.4;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.9);
}
</style>
